module.exports = __webpack_public_path__ + "static/media/face-savoring-food-svgrepo-com.bbc76e4a.svg";